import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ResultSearchEngine } from 'app/shared/models/class/counter/counter';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { PdfService } from 'app/shared/services/pdf/pdf.service';
import { TooltipService } from 'app/shared/services/tooltip/tooltip.service';

@Component({
  selector: 'app-table-search',
  templateUrl: './table-search.component.html',
  styleUrls: ['./table-search.component.scss']
})
export class TableSearchComponent implements OnInit, OnChanges {
  @Input() resultSearch: ResultSearchEngine[];
  @Input() tabsSearchActive: string;

  @Output() booking = new EventEmitter<ResultSearchEngine>();


  displayedColumns: string[] = ['bookingReference', 'offerKey', 'date', 'amount', 'user'];
  dataSource = new MatTableDataSource<ResultSearchEngine>();
  offers: any[];

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  length = 0;
  pageSize = 5;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  pageEvent: PageEvent;
  color: ThemePalette = 'primary';
  resultFiltered: ResultSearchEngine[] = [];

  constructor(
    private pdfService: PdfService,
    private tooltip: TooltipService,
    private faIconService: FaiconService,
  ) { }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges): void {
    const { resultSearch, tabsSearchActive } = changes;
    if (resultSearch || tabsSearchActive) {
      this.initTable(resultSearch?.currentValue || this.resultSearch, tabsSearchActive?.currentValue || this.tabsSearchActive);
    }
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  getTitleColumns(column: string): string {

    const title = {
      bookingReference: 'N° Facture',
      offerKey: 'Id Offre',
      date: 'Date de rés.',
      amount: 'Montant',
      user: 'Client'
    };

    return title[column];
  }

  getColumn(): string[] {
    const column = [...this.displayedColumns];
    let index: number = null;

    switch (this.tabsSearchActive) {
      case 'Invoice':
        index = column.findIndex(c => c === 'offerKey');
        column.splice(index, 1);
        break;
      default:
        break;
    }

    return column;
  }

  goToViewCLient(booking: ResultSearchEngine) {
    this.booking.emit(booking);
  }

  exportPdfBill(book: ResultSearchEngine): void {
    this.pdfService.getPdfBookedSession(book.bookingKey).subscribe({
      next: blob => {
        const data = window.URL.createObjectURL(<any>blob.body);
        const anchor = document.createElement('a');
        anchor.href = data;
        anchor.download = `Facture n° ${book.bookingReference}.pdf`;
        anchor.click();

        setTimeout(() => {
          window.URL.revokeObjectURL(data);
        }, 100);
      }
    });
  }

  getTooltip(value: string): string {
    return this.tooltip.getTooltip(value);
  }

  private initTable(data: ResultSearchEngine[], tab: string): void {
    this.resultFiltered = [...new Set(data?.filter(d => d.type === tab))];
  }



}
